import Login from "../Components/Login/Login";
const Loginpage = () =>{
    return(
        <div className="app-inner-login">
            <div className="container">
                <div className="content-wrap bg-blue">
                    <div className="content-wrap-inner">
                        <Login />
                    </div> 
                </div> 
            </div>
        </div>
    );
} 
export default Loginpage;
